"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { isTrackableVisitorPath } from "@/lib/visitor-log-shared";

export function VisitorPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hasMountedRef = useRef(false);
  const lastTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    const queryString = searchParams.toString();
    const nextPath = `${pathname}${queryString ? `?${queryString}` : ""}`;

    if (!isTrackableVisitorPath(nextPath)) {
      lastTrackedPathRef.current = nextPath;
      return;
    }

    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      lastTrackedPathRef.current = nextPath;
      return;
    }

    if (lastTrackedPathRef.current === nextPath) {
      return;
    }

    lastTrackedPathRef.current = nextPath;

    void fetch("/api/visitor-log/page-view", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ path: nextPath }),
      cache: "no-store",
      keepalive: true,
    }).catch(() => {
      // Ignore background logging failures.
    });
  }, [pathname, searchParams]);

  return null;
}
